import { OccConfig } from '@spartacus/core';

export const shipmentsOccConfig: OccConfig = {
  backend: {
    occ: {
      endpoints: {
        getShipments: '/users/current/shipments/search',
        getShipmentsExport: '/users/current/shipments/export',
      } as any,
    },
  },
};
